@if (showFavouriteToggle) {
    <div class="toggle-favourite">
        <ms-favourite-league-toggle
            [id]="league.id"
            [name]="league.name"
            [sport]="sportId"
            [favToggleIconSize]="'16'"
            [tracking]="{ source: 'Event List' }" />
    </div>
}

@if (showCompetitionLogo) {
    <ms-competition-logo
        class="competition-logo"
        [sportId]="sportId"
        [leagueId]="league.id"
        [fallbackIcon]="fallbackIcon"
        [imageProfile]="league.imageProfile" />
}

<div class="title">
    <span>{{ title }}</span>
</div>
